<template>
    <v-container fluid class="white">
        <v-container fluid class="white">
            <div class="d-flex align-center justify-center mensagem-superior">
            <span class="botao-voltar-area">
                <az-call-to-action @click="voltar"
                                   css-class="text-uppercase d-flex align-center botao-default">
                    <v-icon color="white">
                        keyboard_arrow_left
                    </v-icon>
                    Voltar
                </az-call-to-action>
            </span>
            <span class="green--text area-informacoes-cabecalho">
                <v-icon class="icone-validado" size="18">fas fa-check-circle</v-icon>
                <strong> Documento Válido</strong> - Verificado em {{dataHoraValidacao}}
            </span>
            </div>
            <v-divider role="presentation"></v-divider>
                <az-pdf-document-viewer :src=arquivoSrc
                                    :height="1024 + 'px'"
                                    progress-bar
                                    download-button
                                    @download="$emit('downloadDocumento')"/>

        </v-container>
    </v-container>
</template>
<script>

export default{
    name: 'DocumentoValidado',
    props:{
        arquivoSrc: {
            type: String,
            default: null
        },
        dataHoraValidacao:{
            type: String,
            default: null
        }
    },
    mounted(){
        this.mostrarNotificacaoSucesso('Documento validado com sucesso!')
    },
    methods:{
        voltar(){
            this.$emit('voltar')
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-default
        border 0
        color #777 !important

    .v-icon
        color #777 !important

    .icone-validado
        color var(--v-primary-base) !important

</style>

<style lang="stylus">
    .mensagem-superior
        padding-top 6px
        padding-bottom 6px

    .botao-voltar-area
        width 0
</style>
